export interface PortInfo {
  code: string;
  label: string;
  country?: string;
}

// Curated small port mapping for common cruise ports (three-letter codes for simplicity)
export const PORTS: Record<string, PortInfo> = {
  'hong kong': { code: 'HKG', label: 'Hong Kong Port', country: 'Hong Kong' },
  'hongkong': { code: 'HKG', label: 'Hong Kong Port', country: 'Hong Kong' },
  'hkg': { code: 'HKG', label: 'Hong Kong Port', country: 'Hong Kong' },
  'fukuoka': { code: 'FUK', label: 'Fukuoka Port', country: 'Japan' },
  '福岡': { code: 'FUK', label: 'Fukuoka Port', country: 'Japan' },
  'fuk': { code: 'FUK', label: 'Fukuoka Port', country: 'Japan' },
  'busan': { code: 'PUS', label: 'Busan Port', country: 'Korea' },
  'pus': { code: 'PUS', label: 'Busan Port', country: 'Korea' },
  'kobe': { code: 'KOB', label: 'Kobe Port', country: 'Japan' },
  'kix': { code: 'KIX', label: 'Osaka (Kansai) Port', country: 'Japan' },
  'osaka': { code: 'KIX', label: 'Osaka (Kansai) Port', country: 'Japan' },
  'yokohama': { code: 'YOK', label: 'Yokohama Port', country: 'Japan' },
  'shanghai': { code: 'SHA', label: 'Shanghai Port', country: 'China' },
  'shanghai port': { code: 'SHA', label: 'Shanghai Port', country: 'China' },
  'qingdao': { code: 'TAO', label: 'Qingdao Port', country: 'China' },
  'singapore': { code: 'SIN', label: 'Singapore Port', country: 'Singapore' },
  'manila': { code: 'MNL', label: 'Manila Port', country: 'Philippines' },
  'hong kong port': { code: 'HKG', label: 'Hong Kong Port', country: 'Hong Kong' },
  'nagoya': { code: 'NGO', label: 'Nagoya Port', country: 'Japan' },
  'nagasaki': { code: 'NGS', label: 'Nagasaki Port', country: 'Japan' },
  'kaohsiung': { code: 'KHH', label: 'Kaohsiung Port', country: 'Taiwan' },
  'taipei': { code: 'TPE', label: 'Taipei Port', country: 'Taiwan' },
  'vancouver': { code: 'YVR', label: 'Vancouver Port', country: 'Canada' },
  'los angeles': { code: 'LAX', label: 'Los Angeles Port', country: 'USA' },
  'melbourne': { code: 'MEL', label: 'Melbourne Port', country: 'Australia' },
  'sydney': { code: 'SYD', label: 'Sydney Port', country: 'Australia' },
  'bali': { code: 'BLI', label: 'Bali Port', country: 'Indonesia' },
  'bali port': { code: 'BLI', label: 'Bali Port', country: 'Indonesia' },
  'bkk': { code: 'BKK', label: 'Bangkok (Laem Chabang) Port', country: 'Thailand' },
  'bangkok': { code: 'BKK', label: 'Bangkok (Laem Chabang) Port', country: 'Thailand' },
};

export const findPortCodeByName = (name?: string): PortInfo | undefined => {
  if (!name) return undefined;
  const key = String(name).trim().toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
  if (PORTS[key]) return PORTS[key];
  // try partial includes
  for (const k of Object.keys(PORTS)) {
    if (k.includes(key) || key.includes(k)) return PORTS[k];
  }
  return undefined;
};
